module.exports = __webpack_public_path__ + "images/homepage-step2.svg";


//////////////////
// WEBPACK FOOTER
// ./homepage/images/homepage-step2.svg
// module id = 853
// module chunks = 0